import { observer } from "mobx-react";
import withHeaderFooter, { IWithHeaderFooterProps } from "@/app/csr-src/hocs/with-header-footer";
import styles from "./reviews.module.scss";
import { Button } from "@mui/material";
import { styled as muiStyled } from "@mui/material/styles";
import WaitingReview from "./components/waitingReview";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import React from "react";
import { sendPv, sendClickTrack, EXPOSURE_RECORD } from "@/tracks/25336"
import { useLocation } from 'react-router-dom';
const commonBtnStyles = {
  width: "174px",
  lineHeight: "32px",
  padding: 0,
  cursor: "pointer",
  fontSize: "14px",
};
const ReviewDetailBtn = muiStyled(Button)(() => ({
  ...commonBtnStyles,
  border: "1px solid rgba(136, 139, 148, 1)",
  // backgroundColor: '#999',
  color: "rgba(26, 26, 26, 1)",
  "&:hover": {
    background: "none",
    boxShadow: "none",
  },
}));

const ContinueShoppingBtn = muiStyled(Button)(() => ({
  ...commonBtnStyles,
  color: "#fff",
  background: "linear-gradient(90deg, #FF475D 0%, #FF0F23 100%)",
  // backgroundColor: '#999',
  "&:hover": {
    background: "linear-gradient(90deg, #FF475D 0%, #FF0F23 100%)",
    boxShadow: "none",
  },
}));
const ReviewResult = withHeaderFooter(
  observer(({ JDIHeader }: IWithHeaderFooterProps) => {
    const navigate = useNavigate();

    const goReviewDetail = () => {
      /** 点击事件上报-按钮点击 */
      sendClickTrack.Evaluate_CommentComplete_Btn({ button_name: "1" })
      navigate(`/profile/my-reviews?tab=1`, { replace: true });
    };

    const goHome = () => {
      /** 点击事件上报-按钮点击 */
      sendClickTrack.Evaluate_CommentComplete_Btn({ button_name: "2" })
      window.location.replace(window.location.origin);
    };

    React.useEffect(()=>{
      const searchParams = new URLSearchParams(window?.location.search);
      const orderId = searchParams.get('orderId');
      /** PV-评价完成页 */
      sendPv.Evaluate_CommentComplete({orderId: orderId || "-100", commentId: "-100"});
    }, [])

    return (
      <div className={styles.reviewResultWrapper}>
        <Helmet>
          <title>Review Submitted Successfully | Joybuy</title>
          <meta
            name="description"
            content="We appreciate your review! Your feedback helps us enhance our service. Discover more products and benefit from our delivery assurance at Joybuy."
          />
        </Helmet>
        <div className={styles.status}>
          <div className={styles.iconSuccess}>Submitted Successful</div>
          <div className={styles.btnWrapper}>
            <ReviewDetailBtn 
              exptag={"exp|" + EXPOSURE_RECORD.Evaluate_CommentComplete_Btn_Expo}
              data-exptag-json-param={JSON.stringify({ button_name: "1" })}
              data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
              onClick={goReviewDetail}
            >My reviews</ReviewDetailBtn>
            <ContinueShoppingBtn 
              exptag={"exp|" + EXPOSURE_RECORD.Evaluate_CommentComplete_Btn_Expo}
              data-exptag-json-param={JSON.stringify({ button_name: "2" })}
              data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
              onClick={goHome}
            >Back to home</ContinueShoppingBtn>
          </div>
        </div>
        <div className={styles.reviewsWaiting}>
          <div className={styles.h1}>Awaiting reivew</div>
          <WaitingReview onScrollTop={() => window.scrollTo(0, 0)} pageType="reviewResult" />
        </div>
      </div>
    );
  }),
);

export default ReviewResult;
